import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./ReserveAppointment.module.css";
import TimeSlot from "./TimeSlot";
import { useEffect, useState } from "react";
import { api__getAppointmentDays } from "@/apis/scheduleApis/getAppointmentDays";
import { createTimestampAndNextNDays, getPlatformInfo, toSnakeCase } from "@/utils/GlobalJavascriptFunction";
import { api__getAppointmentTimeSlots } from "@/apis/scheduleApis/getAppointmentTimeSlots";
import postAppointmentData from "@/apis/scheduleApis/postAppointmentData";
import Loader from "@componentsShared/Loader/Loader";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
import { useNavigate } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import DaysComponent from "./DaysComponent";
import RequestInfo from "@/apis/sellTradeForm/RequestInfo";
import SharedPopUp from "@componentsShared/SharedPopUp/SharedPopUp";
import { trackEvents } from "@/common/events/events";
import SellTradeTermsAr from "../../../../data/sell-trade-payment-terms/ar.json";
import SellTradeTermsEn from "../../../../data/sell-trade-payment-terms/en.json";
import { nl2br } from "@/utils/stringHelpers";
export var FULL_DAYS_LIMIT = 21;
export var DAYS_LIMIT = 7;
var PAGES_COUNT = 3;
var getTimeStampFromDayObject = function getTimeStampFromDayObject(obj) {
  return Object.values(obj)[0];
};
var ReserveAppointment = function ReserveAppointment(_ref) {
  var requestId = _ref.requestId,
    _ref$is_reschedule = _ref.is_reschedule,
    is_reschedule = _ref$is_reschedule === void 0 ? 1 : _ref$is_reschedule,
    _ref$showInnerView = _ref.showInnerView,
    showInnerView = _ref$showInnerView === void 0 ? false : _ref$showInnerView,
    _ref$isUserLocation = _ref.isUserLocation,
    isUserLocation = _ref$isUserLocation === void 0 ? undefined : _ref$isUserLocation,
    _ref$onAfterSelect = _ref.onAfterSelect,
    onAfterSelect = _ref$onAfterSelect === void 0 ? undefined : _ref$onAfterSelect,
    _ref$onFeeRequest = _ref.onFeeRequest,
    onFeeRequest = _ref$onFeeRequest === void 0 ? undefined : _ref$onFeeRequest,
    _ref$onAfterSubmit = _ref.onAfterSubmit,
    onAfterSubmit = _ref$onAfterSubmit === void 0 ? undefined : _ref$onAfterSubmit,
    _ref$bigData = _ref.bigData,
    bigData = _ref$bigData === void 0 ? undefined : _ref$bigData,
    _ref$amount_Fee = _ref.amount_Fee,
    amount_Fee = _ref$amount_Fee === void 0 ? undefined : _ref$amount_Fee;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var lang = useLang();
  var terms = lang === "ar" ? SellTradeTermsAr : SellTradeTermsEn;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useState = useState(null),
    myTimestamp = _useState[0],
    setMyTimestamp = _useState[1];
  var _useState2 = useState([]),
    availableDays = _useState2[0],
    setAvailableDays = _useState2[1];
  var _useState3 = useState(null),
    selectedTimestamp = _useState3[0],
    setSelectedTimestamp = _useState3[1];
  var _useState4 = useState(null),
    availableDayTimes = _useState4[0],
    setAvailableDayTimes = _useState4[1];
  var _useState5 = useState({}),
    selectedDayAndTime = _useState5[0],
    setSelectedDayAndTime = _useState5[1];
  var _useState6 = useState(false),
    loader = _useState6[0],
    setLoader = _useState6[1];
  var _useState7 = useState(false),
    errorAppointment = _useState7[0],
    setErrorAppointment = _useState7[1];
  var _useState8 = useState(false),
    showTimeLoader = _useState8[0],
    setShowTimeLoader = _useState8[1];
  var _useState9 = useState(undefined),
    inspectionFees = _useState9[0],
    setInspectionFees = _useState9[1];
  var _useState0 = useState(false),
    TermsBox = _useState0[0],
    setTermsBox = _useState0[1];
  var _useState1 = useState(false),
    showTermsPopUp = _useState1[0],
    setShowTermsPopUp = _useState1[1];
  var _useState10 = useState(false),
    submitReq = _useState10[0],
    setSubmitReq = _useState10[1];
  var _useState11 = useState(false),
    hitDaysReq = _useState11[0],
    setHitDaysReq = _useState11[1];
  useEffect(function () {
    //when come from Re-Sheadual page
    if (onAfterSelect) {
      onAfterSelect(selectedDayAndTime);
    }
  }, [selectedDayAndTime]);
  useEffect(function () {
    if (!requestId) return;
    RequestInfo({
      request_id: requestId
    }).then(function (res) {
      setInspectionFees(bigData.erpResData.amount_fee);
    });
    api__getAppointmentDays(requestId, {
      page: 1,
      limit: DAYS_LIMIT
    }).then(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(daysPatch1) {
        var _daysPatch, day1, timeStampSet, i;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _daysPatch = _slicedToArray(daysPatch1, 1), day1 = _daysPatch[0];
              timeStampSet = false; //const day1 = serverTimeRef.current;
              if (day1) {
                timeStampSet = true;
                setMyTimestamp(createTimestampAndNextNDays(getTimeStampFromDayObject(day1)));
              }
              setAvailableDays(function (prev) {
                return [].concat(_toConsumableArray(prev), _toConsumableArray(daysPatch1));
              });
              i = 2;
            case 1:
              if (!(i <= PAGES_COUNT)) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return api__getAppointmentDays(requestId, {
                page: i,
                limit: DAYS_LIMIT
              }).then(function (daysPatch) {
                var _daysPatch2 = _slicedToArray(daysPatch, 1),
                  dayNew = _daysPatch2[0];
                if (!day1 && !timeStampSet && dayNew) {
                  timeStampSet = true;
                  setMyTimestamp(createTimestampAndNextNDays(getTimeStampFromDayObject(dayNew)));
                }
                setAvailableDays(function (prev) {
                  return [].concat(_toConsumableArray(prev), _toConsumableArray(daysPatch));
                });
              });
            case 2:
              i++;
              _context.n = 1;
              break;
            case 3:
              setHitDaysReq(true);
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())["catch"](function (error) {
      setHitDaysReq(true);
    });
  }, []);
  useEffect(function () {
    selectedTimestamp && setShowTimeLoader(true);
    requestId && selectedTimestamp && api__getAppointmentTimeSlots(requestId, selectedTimestamp).then(function (res) {
      setAvailableDayTimes(res);
      setShowTimeLoader(false);
    });
  }, [selectedTimestamp]);
  var sendNewAppointmentDate = function sendNewAppointmentDate() {
    if (submitReq) {
      return;
    }
    setSubmitReq(true);
    setLoader(true);
    selectedDayAndTime && requestId && postAppointmentData({
      request_id: requestId,
      rescheduled_datestamp: selectedDayAndTime === null || selectedDayAndTime === void 0 ? void 0 : selectedDayAndTime.daytimestamp,
      rescheduled_from_timestamp: selectedDayAndTime === null || selectedDayAndTime === void 0 ? void 0 : selectedDayAndTime.from,
      rescheduled_to_timestamp: selectedDayAndTime === null || selectedDayAndTime === void 0 ? void 0 : selectedDayAndTime.to,
      rescheduling_reason_id: 1,
      is_reschedule: is_reschedule
    }).then(function (res) {
      var _res$data, _res$data2;
      setLoader(false);
      setSubmitReq(true);
      (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 230 && setErrorAppointment(true);
      if ((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code) === 200) {
        // from sell_car_appointment
        if (onFeeRequest && inspectionFees !== 0) {
          onFeeRequest();
        }
        // from Reschedule
        if (!onFeeRequest || inspectionFees === 0) {
          if (showInnerView) {
            var _bigData$Sell_car_for, _bigData$Sell_car_for2, _bigData$Sell_car_for3, _bigData$Sell_car_for4, _bigData$Sell_car_for5, _bigData$Sell_car_for6, _bigData$Sell_car_for7, _bigData$Sell_car_for8, _bigData$Sell_car_for9, _bigData$Sell_car_for0, _bigData$Sell_car_for1, _bigData$userSelectio, _bigData$userSelectio2, _bigData$userSelectio3;
            trackEvents("sell_car_appointment_book", {
              car_make: bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for = bigData.Sell_car_form1) === null || _bigData$Sell_car_for === void 0 ? void 0 : _bigData$Sell_car_for.car_make_id,
              car_model: bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for2 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for2 === void 0 ? void 0 : _bigData$Sell_car_for2.car_model_id,
              car_trim: (_bigData$Sell_car_for3 = bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for4 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for4 === void 0 ? void 0 : _bigData$Sell_car_for4.car_trim_id) !== null && _bigData$Sell_car_for3 !== void 0 ? _bigData$Sell_car_for3 : null,
              car_year: bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for5 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for5 === void 0 ? void 0 : _bigData$Sell_car_for5.year,
              car_odometer_range: bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for6 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for6 === void 0 ? void 0 : _bigData$Sell_car_for6.odometer_range_id,
              car_status: bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for7 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for7 === void 0 ? void 0 : _bigData$Sell_car_for7.car_condition_id,
              car_color: bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for8 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for8 === void 0 ? void 0 : _bigData$Sell_car_for8.color_id,
              ownership_type: toSnakeCase((bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for9 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for9 === void 0 ? void 0 : _bigData$Sell_car_for9.ownership_type) || ""),
              car_city: bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for0 = bigData.Sell_car_form2) === null || _bigData$Sell_car_for0 === void 0 ? void 0 : _bigData$Sell_car_for0.origin_city_id,
              inspection_city: bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for1 = bigData.Sell_car_form2) === null || _bigData$Sell_car_for1 === void 0 ? void 0 : _bigData$Sell_car_for1.city_id,
              estimated_price: bigData.erpResData.minPrice ? "".concat(bigData.erpResData.minPrice, " - ").concat(bigData.erpResData.maxPrice) : null,
              inspection_location: bigData === null || bigData === void 0 ? void 0 : (_bigData$userSelectio = bigData.userSelection) === null || _bigData$userSelectio === void 0 ? void 0 : _bigData$userSelectio.inspection_location_type,
              suggested_price: (_bigData$userSelectio2 = bigData === null || bigData === void 0 ? void 0 : (_bigData$userSelectio3 = bigData.userSelection) === null || _bigData$userSelectio3 === void 0 ? void 0 : _bigData$userSelectio3.asking_price) !== null && _bigData$userSelectio2 !== void 0 ? _bigData$userSelectio2 : null,
              payment_option: null,
              //null for free inspection
              payment_status: null,
              //null for free inspection
              platform: getPlatformInfo(),
              appointment_type: "initial_inspection",
              order_id: requestId
            });
          }
          navigate(createUrl("/schedule/".concat(requestId), _objectSpread(_objectSpread(_objectSpread({
            schedulestep: "success"
          }, showInnerView ? {
            formStep: "sell_car_appointment_book"
          } : {}), isUserLocation !== undefined ? {
            isUserLocation: isUserLocation ? "1" : "0"
          } : {}), amount_Fee !== undefined ? {
            amount_Fee: amount_Fee
          } : {})));
          onAfterSubmit && onAfterSubmit();
        }
      }
    })["catch"](function (error) {
      setSubmitReq(true);
      console.log("appointmentView error", error);
      navigate(createUrl("/schedule/".concat(requestId), {
        schedulestep: "error"
      }));
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, showInnerView ? stl.showInnerView : undefined].join(" ")
  }, !showInnerView && /*#__PURE__*/React.createElement("div", {
    className: stl.headingName
  }, /*#__PURE__*/React.createElement("span", {
    className: "m-show",
    onClick: function onClick() {
      history.back();
    }
  }), /*#__PURE__*/React.createElement("strong", null, t("book_appointment_car_inspection", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.content
  }, availableDays.length === 0 && hitDaysReq && /*#__PURE__*/React.createElement("p", {
    className: stl.noDaysNote + ' !mt-16'
  }, t("error_sorry_inspection_appointments_available_selected", {
    ns: "web_footer"
  })), availableDays.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, t("choose_car_inspection_date", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("time", null, myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.monthName(lang), " (", myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.day(), ")", " ", (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.nextNDays(FULL_DAYS_LIMIT, availableDays).showNextMonth) && " - ".concat(myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.nextMonthName(lang), " (").concat(myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.nextNDays(FULL_DAYS_LIMIT, availableDays).lastAvailableDayNextMonth, ")"), "\u060C ", myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.year()), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DaysComponent, {
    myTimestamp: myTimestamp,
    availableDays: availableDays,
    selectDay: setSelectedTimestamp
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.loadingTimeArea
  }, /*#__PURE__*/React.createElement(TimeSlot, {
    isUserLocation: isUserLocation,
    availableDayTimes: availableDayTimes,
    updateSeletedDayAndTime: function updateSeletedDayAndTime(data) {
      return setSelectedDayAndTime(_objectSpread(_objectSpread({}, data), {}, {
        daytimestamp: selectedTimestamp
      }));
    },
    updatError: function updatError() {
      setErrorAppointment(false);
    },
    errorAppointment: errorAppointment
  }), showTimeLoader && /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true,
    className: stl.timeLoader
  })), showInnerView && inspectionFees !== 0 && /*#__PURE__*/React.createElement("div", {
    className: stl.termsContainr
  }, /*#__PURE__*/React.createElement("label", {
    className: [stl.whtsFlx].join(" ")
  }, /*#__PURE__*/React.createElement("input", {
    onChange: function onChange(target) {
      setTermsBox(!TermsBox);
    },
    type: "checkbox",
    name: "acceptTerms"
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.boxDummy
  }), /*#__PURE__*/React.createElement("span", null, t("agree", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setShowTermsPopUp(true);
    }
  }, t("terms_conditions", {
    ns: "web_checkout_finance"
  })))), availableDays.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: stl.buttonsArea
  }, /*#__PURE__*/React.createElement("button", {
    disabled: showInnerView && inspectionFees !== 0 ? !(selectedDayAndTime !== null && selectedDayAndTime !== void 0 && selectedDayAndTime.from && TermsBox) : !(selectedDayAndTime !== null && selectedDayAndTime !== void 0 && selectedDayAndTime.from),
    className: [stl.btn, "blueBtn"].join(" "),
    onClick: sendNewAppointmentDate
  }, submitReq && /*#__PURE__*/React.createElement(Loader, {
    className: stl.BtnLoadingOnSubmit
  }), t("book_appointment_2", {
    ns: "web_Schedule"
  })), !showInnerView && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      history.back();
    },
    className: [stl.btn, "whtBtn"].join(" ")
  }, t("back_home", {
    ns: "web_Schedule"
  }))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: showTermsPopUp,
    onClose: function onClose() {
      return setShowTermsPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.termsContainer + " p-1"
  }, /*#__PURE__*/React.createElement("h3", {
    className: stl.termsHeading + " mt-1"
  }, terms.title), /*#__PURE__*/React.createElement("p", {
    className: "mt-1",
    dangerouslySetInnerHTML: {
      __html: nl2br(terms.description)
    }
  }))));
};
export default ReserveAppointment;